<template>
    <DrawerAccordion id="note" :title="$t.__('common.labels.note')" class="sidemenu-overview-note">
        <!-- NOTE -->
        <div v-if="permissionsToEdit" v-click-outside.stop="submitNote">
            <div>
                <RichText
                    ref="refNotesRichText"
                    v-model="note"
                    :placeholder="$t.__('common.actions.write_note')"
                    :options="optionsRichText"
                    :is-custom="true"
                    :show-rich-text-menu="false"
                    class="notes-richtext"
                />
                <RichTextMenu
                    v-if="richTextEditor"
                    :editor-menu="richTextEditor"
                    :options="optionsRichText"
                    class="notes-richtext-menu"
                />
            </div>

            <CompassPlainButton
                v-if="canImportOldNote"
                :label="$t.__('overview.Overview.see_old_datas')"
                class="mt-1 mb-1"
                size="small"
                left-icon="attachment"
                @click="openDialog('import-old-note')"
            />
            <div class="sidemenu-overview-note__buttons">
                <CompassButton
                    :label="$t.__('common.actions.cancel')"
                    size="small"
                    type="secondary"
                    @click="cancelEditNote"
                />
                <CompassButton
                    :label="$t.__('common.actions.save')"
                    size="small"
                    :loading="isloading"
                    @click.stop="submitNote"
                />
            </div>
        </div>

        <div
            v-else
            class="sidemenu-overview-note__content typographies-paragraph-medium-regular"
            v-html="note"
        />
    </DrawerAccordion>
</template>

<script>
import DrawerAccordion from 'vcomponents/common/drawer/accordion/DrawerAccordion.vue';
import RichText from 'vcomponents/richtext/RichText.vue';
import RichTextMenu from 'vcomponents/richtext/RichTextMenu.vue';

export default {
    components: {
        DrawerAccordion,
        RichText,
        RichTextMenu,
    },
    props: {
        permissionsToEdit: {
            type: Boolean,
            default: false,
        },
        canImportOldNote: {
            type: Boolean,
            default: false,
        },
        overviewType: {
            type: String,
            required: true,
        },
        linkedid: {
            type: Number,
            required: true,
        },
        linkedtype: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            note: '',
            loadingNote: false,
            previousNote: '',
            oldNote: '',
            optionsRichText: [
                'Heading',
                'Bold',
                'Italic',
                'Underline',
                'BulletList',
                'OrderedList',
                'TextAlign',
                'Divider',
                'Link',
            ],
            richTextEditor: null,
            isloading: false,
        };
    },
    computed: {
        informations() {
            return this.$store.getters.dataFetch.informations;
        },
        isOpportunity() {
            return this.linkedtype === 'opportunity';
        },
    },
    created() {
        this.getNote();
        if (this.isOpportunity) {
            this.getOldNote();
        }
    },
    mounted() {
        // Get the editor instance from RichText component
        this.richTextEditor = this.$refs.refNotesRichText.editor;
    },
    methods: {
        isNote(note) {
            return ['description', 'stickyNote', 'brief'].includes(note);
        },
        getOldNote() {
            this.oldNote = this.informations.find((item) => item.key === 'stickyNote')?.value || '';
        },
        getNote() {
            const storedNote = this.informations.find((item) => this.isNote(item.key));

            if (storedNote?.value) {
                this.note = storedNote.value;
                this.previousNote = storedNote.value;
            }
        },
        cancelEditNote() {
            this.note = this.previousNote;
        },

        submitNote() {
            if (this.previousNote !== this.note) {
                this.isloading = true;

                ApiClient.patch(
                    `/${this.overviewType}/${this.linkedid}/note`,
                    {},
                    { note: this.note },
                )
                    .then(() => {
                        this.previousNote = this.note;
                        this.$pushToast({
                            type: 'success',
                            close: true,
                            text: this.$t.__('overview.notes.success'),
                        });
                    })
                    .catch(() => {
                        this.$pushToast({
                            type: 'error',
                            close: true,
                            text: this.$t.__('overview.notes.error'),
                        });
                    })
                    .finally(() => {
                        this.isloading = false;
                    });
            }
        },
    },
};
</script>
<style lang="scss" scoped>
.sidemenu-overview-note {
    &::v-deep {
        .drawer-accordion__content-wrapper {
            padding-left: var(--spacing-1);
            padding-right: var(--spacing-1);
            padding-top: var(--spacing-0);
        }

        .notes-richtext {
            border-radius: var(--spacing-0);
            border: 1px solid transparent;
            padding: 3px;

            &.is-focus {
                border-color: var(--colors-common-border-focus);
            }
        }
    }

    &__content {
        p:not(:last-child) {
            margin: 0 0 var(--spacing-3);
        }
    }

    &__buttons {
        display: flex;
        gap: var(--spacing-1);
        justify-content: flex-end;
        margin-top: var(--spacing-1);
        padding: 0 var(--spacing-0);
    }
}
</style>
